import { render, staticRenderFns } from "./DisinfectedPallet.vue?vue&type=template&id=5c16bf6e"
import script from "./DisinfectedPallet.vue?vue&type=script&lang=js"
export * from "./DisinfectedPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports